import { Image, ImageProps } from 'theme-ui'

const Aerodrome = (props: ImageProps) => {
  return <Image width={16} src="/imgs/aerodrome.png" {...props} />
}
export default Aerodrome
